// extracted by mini-css-extract-plugin
export default {"ImageViewer":"QpeuZ","wrapper":"rld84","isFullScreen":"XvzlW"};